import ApiService from "../../../services/ApiService";

const GEO_CACHE_KEY = "wc_phone_geo_country";
const GEO_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

const DIAL_CODE_TO_ISO = {
  1: "us",
  45: "dk",
  49: "de",
  55: "br",
  91: "in",
  972: "il",
};

const ISO_TO_DIAL = Object.fromEntries(
  Object.entries(DIAL_CODE_TO_ISO).map(([dial, iso]) => [iso, dial])
);

const readGeoCache = () => {
  try {
    const raw = sessionStorage.getItem(GEO_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.country || !parsed?.expiry || parsed.expiry < Date.now()) {
      sessionStorage.removeItem(GEO_CACHE_KEY);
      return null;
    }
    return String(parsed.country).toLowerCase();
  } catch (e) {
    return null;
  }
};

const writeGeoCache = (country) => {
  try {
    sessionStorage.setItem(
      GEO_CACHE_KEY,
      JSON.stringify({
        country: String(country).toLowerCase(),
        expiry: Date.now() + GEO_CACHE_TTL_MS,
      })
    );
  } catch (e) {
    // ignore
  }
};

const PhoneInputService = {
  dialCodeToIso(dialCode) {
    const digits = String(dialCode || "").replace(/\D/g, "");
    return DIAL_CODE_TO_ISO[digits] || "";
  },

  isoToDialCode(iso) {
    const normalized = String(iso || "").toLowerCase();
    return ISO_TO_DIAL[normalized] || "";
  },

  async getGeoLocation() {
    const cached = readGeoCache();
    if (cached) {
      return cached;
    }

    try {
      const info = await ApiService.getGeoLocation();
      // ipapi.co exposes ISO-2 as both `country` and `country_code`
      const country = String(info?.country_code || info?.country || "").toLowerCase();
      if (country && country.length === 2) {
        writeGeoCache(country);
        return country;
      }
      return "";
    } catch (e) {
      return "";
    }
  },
};

export default PhoneInputService;
